import { Component } from '@angular/core';
import { IQuestionnaireWorkflowItem } from '@interfaces/interfaces';
import { WorkflowStatus } from '@api/projects/interfaces';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';

@Component({
	selector: 'app-workflow-detail-showcase',
	templateUrl: './workflow-detail-showcase.component.html'
})
export class WorkflowDetailShowcaseComponent {
	selectedViewMode = 'compact';
	questionnaireWorkflowItems: IQuestionnaireWorkflowItem[] = [
		{
			id: 'test',
			showOverview: true,
			name: 'Showcase 1',
			description: 'Showcase Test nicht gestarted',
			groups: [],
			category: 'Questionnaire',
			type: 'Questionnaire',
		},
		{
			id: 'test2',
			showOverview: true,
			name: 'Showcase 2',
			description: 'Showcase Test gestarted',
			groups: [],
			category: 'Questionnaire',
			type: 'Questionnaire',
		},
		{
			id: 'test3',
			showOverview: true,
			name: 'Showcase 3',
			description: 'Showcase Test beendet',
			groups: [],
			category: 'Questionnaire',
			type: 'Questionnaire',
		},
	];
	isResetModalVisible: boolean;
	isPopoverVisible: boolean;
	workflowStatus: WorkflowStatus = {
		pid: 'test',
		status: {
			test: {
				completed: false,
				started: false,
			},
			test2: {
				completed: false,
				started: true,
			},
			test3: {
				completed: true,
				started: false,
			}
		}
	};
	workflowStartedString: string[] = [];
	workflowStartedContinue: string[] = [];
	public workflowStartedContinueSplitButton: SplitButtonElement[][];
	public workflowFinishedSplitButton: SplitButtonElement[][];
	public distractionFreeWizardIcon = 'trello';
	public compactViewIcon = 'book-open';

	showResetModal(): void {
		this.isResetModalVisible = true;
		this.isPopoverVisible = false;
	}

	handleResetCancel(): void {
		this.isResetModalVisible = false;
	}

	private parseWorkflowStatusToText(workflowItemId: string, index: number): void {
		this.workflowStartedString[index] = this.workflowStatus.status[workflowItemId]?.started ?
			'status.started' :
			'status.unstarted';
		this.workflowStartedContinue[index] = this.workflowStatus.status[workflowItemId]?.started ?
			'actions.continue' :
			'actions.start';
	}

	constructor() {
		this.questionnaireWorkflowItems.forEach((item, index) => {
			this.parseWorkflowStatusToText(item.id, index);
		});
		this.initSplitButtons();
	}

	public initSplitButtons(): void {
		this.workflowStartedContinueSplitButton = [];
		this.workflowFinishedSplitButton = [];

		this.questionnaireWorkflowItems.forEach((questionnaireWorkflowItem, index) => {
			//Splitbuttons die für beide Karten verfügbar sind
			const showOverviewInCompactButton: SplitButtonElement = {
				title: 'workflow.show_OverviewInCompact',
				type: 'primary',
				icon: this.compactViewIcon,
			};
			const showOverviewInWizardButton: SplitButtonElement = {
				title: 'workflow.show_OverviewInWizard',
				type: 'primary',
				icon: this.distractionFreeWizardIcon,
			};
			const resetButton: SplitButtonElement = {
				title: 'workflow.resetData',
				type: 'primary',
				icon: 'trash',
				hasDivider: true,
			};

			//SplitButtons Erstellen, zuerst für Starten und fortsetzen.
			this.workflowStartedContinueSplitButton[index] = [];
			this.workflowStartedContinueSplitButton[index].push({
				title: this.workflowStartedContinue[index],
				type: 'primary',
			});
			//Kompakt Modus ausgewählt
			if (this.selectedViewMode === 'compact') {
				if (this.workflowStartedString[index] === 'status.unstarted') {
					this.workflowStartedContinueSplitButton[index].push({
						title: 'workflow.startInCompact',
						type: 'primary',
						icon: this.compactViewIcon,
					});
				}
				else if (this.workflowStartedString[index] === 'status.started'
					&& !this.workflowStatus?.status[questionnaireWorkflowItem.id]?.completed) {
					this.workflowStartedContinueSplitButton[index].push({
						title: 'workflow.continueInCompact',
						type: 'primary',
						icon: this.compactViewIcon,
					});
				}
				if (questionnaireWorkflowItem?.showOverview) {
					this.workflowStartedContinueSplitButton[index].push(showOverviewInCompactButton);
				}
			}
			//Ablenkungsfreier Wizard Ausgewählt
			else if (this.selectedViewMode === 'wizard') {
				if (this.workflowStartedString[index] === 'status.unstarted') {
					this.workflowStartedContinueSplitButton[index].push({
						title: 'workflow.startInWizard',
						type: 'primary',
						icon: this.distractionFreeWizardIcon,
					});
				}
				else if (this.workflowStartedString[index] === 'status.started'
					&& !this.workflowStatus?.status[questionnaireWorkflowItem.id]?.completed) {
					this.workflowStartedContinueSplitButton[index].push({
						title: 'workflow.continueInWizard',
						type: 'primary',
						icon: this.distractionFreeWizardIcon,
					});
				}
				if (questionnaireWorkflowItem?.showOverview) {
					this.workflowStartedContinueSplitButton[index].push(showOverviewInWizardButton);
				}
			}
			if (this.workflowStartedString[index] === 'status.started'
				|| this.workflowStatus?.status[questionnaireWorkflowItem.id]?.completed) {
				this.workflowStartedContinueSplitButton[index].push(resetButton);
			}

			//Schritt beendet Button
			this.workflowFinishedSplitButton[index] = [];
			if (questionnaireWorkflowItem.showOverview) {
				this.workflowFinishedSplitButton[index].push({
					title: 'workflow.show_Overview',
					type: 'primary',
				});
			}
			else {
				this.workflowFinishedSplitButton[index].push({
					title: 'workflow.show',
					type: 'primary',
				});
			}
			//Kompaktmouds ausgewählt
			if (this.selectedViewMode === 'compact') {
				if (questionnaireWorkflowItem.showOverview) {
					this.workflowFinishedSplitButton[index].push({
						title: 'workflow.show_OverviewInCompact',
						type: 'primary',
						icon: this.compactViewIcon,
					});
				}
				this.workflowFinishedSplitButton[index].push({
					title: 'workflow.showInCompact',
					type: 'primary',
					icon: this.compactViewIcon,
				});
			}
			//Anlenkungsfreier Wizard ausgewählt
			if (this.selectedViewMode === 'wizard') {
				if (questionnaireWorkflowItem.showOverview) {
					this.workflowFinishedSplitButton[index].push({
						title: 'workflow.show_OverviewInWizard',
						type: 'primary',
						icon: this.distractionFreeWizardIcon,
					});
				}
				this.workflowFinishedSplitButton[index].push({
					title: 'workflow.showInWizard',
					type: 'primary',
					icon: this.distractionFreeWizardIcon,
				});
			}
			this.workflowFinishedSplitButton[index].push(resetButton);
		});
	}
}
